import { useGallery } from "@/hooks/useSiteContent";
import { resolveImageUrl } from "@/lib/api";

const FALLBACK_TILES = [
  { span: "md:col-span-8 md:row-span-2", image_url: "/assets/photos/IMG_3427.jpeg", title: "Quesadilla Manager's Special", sub: "Wings, quesadillas, fries — Memphis on a tray" },
  { span: "md:col-span-4", image_url: "/assets/photos/IMG_3967.jpeg", title: "The Monster", sub: "3 patties · triple cheese · onion crispers" },
  { span: "md:col-span-4", image_url: "/assets/photos/IMG_9488.jpeg", title: "Dynamic Duo Philly", sub: "Steak + grilled shrimp, melted cheese" },
  { span: "md:col-span-5", image_url: "/assets/photos/IMG_2925.jpeg", title: "Old School Fries", sub: "Loaded heavy — chili, cheese, jalapeños" },
  { span: "md:col-span-7", image_url: "/assets/photos/IMG_3383.jpeg", title: "Banana Pudding", sub: "Made fresh daily — a whole nother level" },
];

export const Gallery = () => {
  const items = useGallery();
  const tiles = items && items.length ? items : FALLBACK_TILES;

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#0A0A0A] py-20 md:py-28 border-t border-[#222]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#E60000] font-bold mb-3">Eats Gallery</div>
            <h2 className="font-heading text-5xl sm:text-6xl text-white">
              What's <span className="text-[#E60000]">Cookin'</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md">
            A peek at the food that built our reputation. Tap the menu when you're ready to get one in your hands.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[200px] gap-4">
          {tiles.map((t, i) => (
            <div
              key={t.id || i}
              data-testid={`gallery-tile-${i}`}
              className={`relative overflow-hidden border border-[#222] group ${t.span || "md:col-span-4"} h-48 md:h-auto`}
            >
              <img src={resolveImageUrl(t.image_url)} alt={t.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-4 md:p-6">
                {t.sub && <div className="text-[10px] uppercase tracking-widest text-[#E60000] font-bold mb-1">{t.sub}</div>}
                <div className="font-heading text-2xl md:text-3xl text-white leading-none">{t.title}</div>
              </div>
              <div className="absolute top-3 right-3 bg-black/80 text-white text-[10px] uppercase tracking-widest font-bold px-2 py-1 border border-[#E60000]/50">
                {String(i + 1).padStart(2, "0")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
